import $ from 'jquery';

import loadImage from './load-image';
import { setCSSPropScrollbarWidth } from './set-css-props';

$(document).ready(() => {
  $('body').attr('ontouchstart', '');

  setCSSPropScrollbarWidth();
});

$(window).on('load', () => {
  //$('img').loadImage();
});



// WEBPACK FOOTER //
// ./styleguide/src/assets/base/base.js